import { JobQuality } from '../models';

export const getJobQuality = (qualityPercent: number): JobQuality => {
  if (qualityPercent > 66) {
    return JobQuality.HIGH;
  }
  if (qualityPercent > 33) {
    return JobQuality.MEDIUM;
  }
  return JobQuality.LOW;
};
